import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


const OurAttorneysTwo = () => {
    return(
        <>
        <section className="our-attorneys-sections section-padding-four">
            <div className="default-container">
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="sec-o-title text-center pb-3">
                            <h2 className="transform-uppercase">OUR <span>ATTORNEYS</span></h2>
                        </div>
                    </div>
                </div>
                <OwlCarousel 
                items={4}
                loop={true}
                nav={false}
                dots={false}
                autoplay={true}
                margin={30}
                className="row clearfix owl-carousel">
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                            <img src="images/attorneys/at-01-255x330.png" alt="attorney" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                            <div className="mt-3">
                                <h6 className="mb-0 font-weight-bold"><Link to="#">Alex Jacobson</Link></h6>
                                <p className="attorney-work">Corporate Lawyer</p>
                            </div>
                            <ul className="list-inline mb-0 text-center">
                                <li className="list-inline-item"><Link to="#" className=""><i className="fa fa-facebook"></i></Link></li>
                                <li className="list-inline-item"><Link to="#" className=""><i className="fa fa-instagram"></i></Link></li>
                                <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p"></i></Link></li>
                                <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                            <img src="images/attorneys/at-02-255x330.png" alt="attorney" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                            <div className="mt-3">
                                <h6 className="mb-0 font-weight-bold"><Link to="#">Polard Andrew</Link></h6>
                                <p className="attorney-work">Corporate Lawyer</p>
                            </div>
                            <ul className="list-inline mb-0 text-center">
                                <li className="list-inline-item"><Link to="#" className=""><i className="fa fa-facebook"></i></Link></li>
                                <li className="list-inline-item"><Link to="#" className=""><i className="fa fa-instagram"></i></Link></li>
                                <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p"></i></Link></li>
                                <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                            <img src="images/attorneys/at-03-255x330.png" alt="attorneys" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                            <div className="mt-3">
                                <h6 className="mb-0 font-weight-bold"><Link to="#">john denver</Link></h6>
                                <p className="attorney-work">Corporate Lawyer</p>
                            </div>
                            <ul className="list-inline mb-0 text-center">
                                <li className="list-inline-item"><Link to="#" className=""><i className="fa fa-facebook"></i></Link></li>
                                <li className="list-inline-item"><Link to="#" className=""><i className="fa fa-instagram"></i></Link></li>
                                <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p"></i></Link></li>
                                <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="attorney-box text-center">
                        <div className="attorney-img">
                            <img src="images/attorneys/at-04-255x330.png" alt="attorney" className="img-fluid mx-auto d-block" />
                        </div>
                        <div className="attorney-social-details">
                            <div className="mt-3">
                                <h6 className="mb-0 font-weight-bold"><Link to="#">ALina Kevin</Link></h6>
                                <p className="attorney-work">Corporate Lawyer</p>
                            </div>
                            <ul className="list-inline mb-0 text-center">
                                <li className="list-inline-item"><Link to="#" className=""><i className="fa fa-facebook"></i></Link></li>
                                <li className="list-inline-item"><Link to="#" className=""><i className="fa fa-instagram"></i></Link></li>
                                <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p"></i></Link></li>
                                <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                </OwlCarousel>
            </div>
        </section>
        </>
    )
}

export default OurAttorneysTwo;